import {
  STACK_ADD_CARD,
  STACK_CREATE,
  STACK_EDIT_GOLD,
  STACK_EDIT_SILVER,
  STACK_DELETE
} from '../actionTypes';

const initialState = {
  byId: {},
  allIds: []
};

export const wildCardsById = {
  1: {
    name: 'gold',
    value: 50000,
    count: 4
  },
  2: {
    name: 'silver',
    value: 25000,
    count: 8
  }
};

//a list of the cards and their values
export const cardsById = {
  home: {
    name: 'home',
    value: 20000,
    count: 8
  },
  jewels: {
    name: 'jewels',
    value: 15000,
    count: 10
  },
  classic_auto: {
    name: 'classic auto',
    value: 15000,
    count: 10
  },
  bank_account: {
    name: 'bank account',
    value: 10000,
    count: 10
  },
  coin_collection: {
    name: 'coin collection',
    value: 10000,
    count: 10
  },
  stocks: {
    name: 'stocks',
    value: 10000,
    count: 10
  },
  baseball_cards: {
    name: 'baseball cards',
    value: 5000,
    count: 10
  },
  cash_under_matress: {
    name: 'cash under matress',
    value: 5000,
    count: 10
  },
  stamp_collection: {
    name: 'stamp collection',
    value: 5000,
    count: 10
  },
  piggy_bank: {
    name: 'piggy bank',
    value: 5000,
    count: 10
  }
};

export const calcCardValue = (cardId, count) => {
  return cardsById[cardId].value * count;
};

export default function(state = initialState, action) {
  if (action.payload)
    var {
      id, //todo convert to stackid
      cards,
      count,
      owner,
      goldCount,
      silverCount,
      stackId,
      cardId
    } = action.payload;

  switch (action.type) {
    case STACK_CREATE:
      return {
        // ...state, unsure
        byId: {
          ...state.byId,
          [id]: {
            id,
            owner,
            cards, //default values
            goldCount,
            silverCount,
            value: calcCardValue(cards[0].cardId, cards[0].count)
          }
        },
        allIds: [...state.allIds, id]
      };
    case STACK_DELETE:
      let temp = { ...state.byId };

      delete temp[stackId];
      return {
        ...state,
        byId: {
          ...temp
        }
      };
    case STACK_ADD_CARD: //now is kinda edit card. but there's only one sooo
			// const { stackId, cardId } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [stackId]: {
            ...state.byId[stackId],
            cards: [{ cardId, count }],
            value: calcCardValue(cardId, count)
          }
        }
      };
    case STACK_EDIT_GOLD:
      // const { stackId, goldCount } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [stackId]: {
            ...state.byId[stackId],
            goldCount
          }
        }
      };
    case STACK_EDIT_SILVER:
      // const { stackId, silverCount } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [stackId]: {
            ...state.byId[stackId],
            silverCount
          }
        }
      };
    default:
      return state;
  }
}
